module.exports = __webpack_public_path__ + "images/emoji/taxi.c8fef666a6b6ee626a40.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/taxi.png
// module id = mkpk
// module chunks = 2